import { useRouteData } from "@solidjs/router";
import { Component, Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { loadAds, loadOtherAwardsCms, setPageTitle, setSubMenu } from "../../app";
import { CMS } from "../../components/cms/cms";
import { SalonSubmissionAwardGrouping } from "../../Types";
import { AwardGroupingList } from "../../components/artwork-grouping-list";
import { RunnerUp } from "../../components/runner-up";
import { ScrollToTarget } from "../../components/scroll-to-target";
import { cleanTargetName } from "../../library/common";

type State =  {
    isContentReady: boolean;
}

const Heading : Component<any> = (props) => {
    return (
        <>
            <div class="white-divider" style="background-color: #fff;">
                <div class="container" style="text-align: center;">
                    <h3 style="font-family: 'Gill Sans MT'; font-size: 4em;">
                        {props.children}
                    </h3>
                </div>
            </div>
        </>
    )
}

const Divider : Component<any> = (props) => {
    return (
        <>
            <div class="white-divider" style="background-color: #fff;">
                <div class="container" style="text-align: center;">
                    <p>
                        {props.children}
                    </p>
                </div>
            </div>
        </>
    )
}

type AwardLinkProps = {
    id: string;
    children: string;
}

const AwardLink : Component<AwardLinkProps> = (props) =>
<span class="award-link" data-target={cleanTargetName(props.children)}>
    <CMS text id={props.id}>{props.children}</CMS>
</span>;

export function OtherAwardsPage() {
    const [grouping, setGrouping] = createStore<SalonSubmissionAwardGrouping[]>([]);
    const [state, setState] = createStore<State>({ isContentReady: false });
    const getItems = (award: string) => grouping.filter(x=> x.Award.indexOf(award) >= 0);
    onMount(async() => {
        const routeData = await useRouteData() as any;
        setGrouping(routeData.grouping);
        await loadOtherAwardsCms();
        await loadAds("10th-arc-salon/introduction");
        setPageTitle({ id: "10th-arc-salon/other-awards::title", text: "Other Awards" });
        setSubMenu("Other Awards");
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <ScrollToTarget selector=".award-link" nextElementSiblingOffset={0}>
                    <div>
                        <div class="category-intro">
                            <div>
                                <div style="padding: 0 40px; text-align: center;">
                                    <div style="display: inline-block; margin-right: 40px; text-align: left; vertical-align: top;">
                                        <ul>
                                            <li style="list-style: none;">
                                                <h3 style="font-family: 'Oswald'; font-size: 2em;">
                                                    <AwardLink id="10th-arc-salon/other-awards::heading/other-awards">Purchase Awards</AwardLink>
                                                </h3>
                                                <hr />
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/arc-purchase-awards">ARC Purchase Awards</AwardLink>
                                            </li>
                                            <li style="list-style: none;">
                                                <h3 style="font-family: 'Oswald'; font-size: 2em;">
                                                    <AwardLink id="10th-arc-salon/other-awards::heading/other-awards">Publication Awards</AwardLink>
                                                </h3>
                                                <hr />
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/fine-art-connoisseur-magazine-award">Fine Art Connoisseur Magazine Award</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/pleinair-magazine-award">PleinAir Magazine Award</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/american-art-collector-award">American Art Collector Award</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/western-art-collector-award">Western Art Collector Award</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/american-fine-art-magazine-award">American Fine Art Magazine Award</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/international-artist-award">International Artist Award</AwardLink>
                                            </li>
                                        </ul>
                                    </div>
                                    <div style="display: inline-block; margin-right: 40px; text-align: left; vertical-align: top;">
                                        <ul>
                                            <li style="list-style: none;">
                                                <h3 style="font-family: 'Oswald'; font-size: 2em;">
                                                    <AwardLink id="10th-arc-salon/other-awards::heading/other-awards">Other Awards</AwardLink>
                                                </h3>
                                                <hr />
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/most-ambitious">Most Ambitious</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/best-portrait">Best Portrait</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/best-nude">Best Nude</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/best-social-commentary">Best Social Commentary</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/best-trompe-loeil">Best Trompe L'oeil</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/dual-category-awards">Dual Category Awards</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/chairmans-choice-awards">Chairman's Choice Awards</AwardLink>
                                            </li>
                                            <li>
                                                <AwardLink id="10th-arc-salon/other-awards::heading/arc-staff-awards">ARC Staff Awards</AwardLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Heading>
                        Purchase Awards
                    </Heading>
                    <Divider>
                        ARC Purchase Awards are given at the sole discretion of ARC's Chairman, Frederick C. Ross and Chief Operating Officer, Kara Lysandra Ross. ARC purchase awards go into the Art Renewal Center's growing collection. Retail prices are shown.
                    </Divider>
                    <AwardGroupingList
                        items={getItems("ARC Purchase")}
                        showPrizeMoney={true} showDivider={true}
                        heading="ARC Purchase Awards"
                    />
                    <Heading>
                        Publication Awards
                    </Heading>
                    <Divider>
                        For the first year we had an additional four magazines participating in the ARC Salon. American Art Collector Magazine, Western Art Collector Magazine, American Fine Art Magazine, and International Artist Magazine. All these awards were picked by the magazines' editor Joshua Rose.
                    </Divider>
                    <AwardGroupingList
                        items={getItems("Fine Art Connoisseur")}
                        showDivider={true}
                        heading="Fine Art Connoisseur Magazine Award"
                    />
                    <AwardGroupingList
                        items={getItems("PleinAir")}
                        showDivider={true}
                        heading="PleinAir Magazine Award"
                    />
                    <AwardGroupingList
                        items={getItems("American Art Collector")}
                        showDivider={true}
                        heading="American Art Collector Award"
                    />
                    <AwardGroupingList
                        items={getItems("Western Art Collector")}
                        showDivider={true}
                        heading="Western Art Collector Award"
                    />
                    <AwardGroupingList
                        items={getItems("American Fine Art Magazine")}
                        showDivider={true}
                        heading="American Fine Art Magazine Award"
                    />
                    <AwardGroupingList
                        items={getItems("International Artist")}
                        showDivider={true}
                        heading="International Artist Award"
                    />
                    <AwardGroupingList
                        items={getItems("International Artist")}
                        showDivider={true}
                        heading="International Artist Award"
                    />
                    <Heading>
                        Other Awards
                    </Heading>
                    <Divider>
                        Below are our other ARC awards, including Most Ambitious Work, Best Nude, Best Social Commentary, Best Trompe L'oeil, as well as the runner up for these awards. In addition, we have our Dual Category Award winners which ranked in the top 20 works in more then one category, but did not place in first, second, or third. Finally we have our Chairman's Choice Awards, chosen by our ARC Chairman, Frederic C. Ross, and our ARC Staff Awards, each one chosen by one member of the ARC Staff.
                    </Divider>
                    <RunnerUp baseAwardName="Most Ambitious" model={grouping} />
                    <RunnerUp baseAwardName="Best Portrait" model={grouping} />
                    <RunnerUp baseAwardName="Best Nude" model={grouping} />
                    <RunnerUp baseAwardName="Best Social Commentary" model={grouping} />
                    <RunnerUp baseAwardName="Best Trompe L'oeil" model={grouping} />
                    <RunnerUp baseAwardName="Best Trompe L'oeil" model={grouping} />
                    <AwardGroupingList
                        items={getItems("Dual Category")}
                        showDivider={true}
                        heading="Dual Category Awards"
                    />
                    <AwardGroupingList
                        items={getItems("Chairman")}
                        showDivider={true}
                        heading="Chairman's Choice Awards"
                    />
                    <AwardGroupingList
                        items={getItems("ARC Staff")}
                        showDivider={true}
                        heading="ARC Staff Awards"
                    />
                </ScrollToTarget>
            </Show>
        </>
    )
}